export default function useDataFormatter() {
	const remapObjectToArray = (data: Record<string, string> | undefined) => {
		if (data) {
			const remapped: { iso: string; value: string }[] = [];
			for (const key in data) {
				const value = data[key];
				if (value) {
					remapped.push({
						iso: key,
						value,
					});
				}
			};
			return remapped;
		}
		return undefined;
	};

	return { remapObjectToArray };
}
